export default "__VITE_ASSET__Dk3U8Enf__"